import React, { useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AppService, AppConfig, AppConfigService } from '@aperza/util';
import NavBar from '../navbar/NavBar';
import SearchResultBar from '../searchResult/SearchResultBar';
import NavBarForNews from '../navbar/NavBarForNews';
import MarketplaceBar from '../navbar/MarketplaceBar';
import UserSection from '../user/UserSection';
import Notification from '../common/Notification';
import EnvironmentIndicator from '../common/EnvironmentIndicator';
const appConfig = AppService.appConfig();
const Header = (props) => {
    const { viewer, suggestSearch, disableNavBar, disableMarketplaceBanner } = props;
    const { i18n } = useTranslation();
    const onMessage = (event) => {
        if (event) {
            if (event.origin.includes('//id.')) {
                try {
                    const data = JSON.parse(event.data);
                    if (data.action === 'closeDialog' || data.action === 'close') {
                        if (props.refetch) {
                            props.refetch();
                        }
                    }
                }
                catch (e) { }
            }
        }
    };
    useEffect(() => {
        if (window.addEventListener) {
            window.addEventListener('message', onMessage, false);
        }
        else if (window.attachEvent) {
            window.attachEvent('onmessage', onMessage, false);
        }
    }, []);
    const keyword = AppConfigService.getSearchKeyword();
    const style = {};
    // if (keyword) {
    //   style = {
    //     paddingBottom: '0px',
    //   }
    // }
    const showTopBar = AppConfigService.shouldShowMarketplaceTopBanner();
    const showSearchResultBar = [AppConfig.APERZA_SEARCH, AppConfig.APERZA_EC].includes(appConfig.serviceType) && keyword;
    return (React.createElement("div", { className: clsx('aw-container', {
            'aw-locale-en': i18n.language === 'en',
        }, {
            'aw-locale-ja': i18n.language !== 'en',
        }) },
        React.createElement(EnvironmentIndicator, null),
        React.createElement("div", null,
            (!disableMarketplaceBanner || showTopBar) && React.createElement(MarketplaceBar, null),
            React.createElement("div", { className: "aperza-header", style: style },
                React.createElement(UserSection, { viewer: viewer, suggestSearch: suggestSearch, ...props }),
                !disableNavBar && !keyword && React.createElement(NavBar, { viewer: viewer, ...props }),
                showSearchResultBar && React.createElement(SearchResultBar, { viewer: viewer, ...props })),
            appConfig.serviceType == AppConfig.APERZA_NEWS && React.createElement(NavBarForNews, { ...props }),
            React.createElement(Notification, null))));
};
Header.propTypes = {
    viewer: PropTypes.any,
    suggestSearch: PropTypes.any,
    disableSuggest: PropTypes.bool,
    disableCartBadge: PropTypes.bool,
    disableLogin: PropTypes.bool,
    disableNavBar: PropTypes.bool,
    disableNavCatalog: PropTypes.bool,
    disableNavMarketplace: PropTypes.bool,
    disableNavNews: PropTypes.bool,
    disableNavExhibitions: PropTypes.bool,
    disableNavManufacturers: PropTypes.bool,
    disableNavShops: PropTypes.bool,
    disableNavPromote: PropTypes.bool,
    disableNavRegisterAccount: PropTypes.bool,
    disableMarketplaceBanner: PropTypes.bool,
    refetch: PropTypes.func,
};
export default Header;
